import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasFormControl = ({
  children,
  className,
  fullWidth,
  error,
  // eslint-disable-next-line no-unused-vars
  sx,
  ...props
}) => (
  <div className={cn('flex flex-col gap-1', fullWidth && 'w-full', className)} {...props}>
    {children}
  </div>
)

AdasFormControl.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  error: PropTypes.bool
}
